export default __webpack_public_path__ + "static/media/image-25.7a42cfd4.png";